import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import { Button } from 'src/components/common';

export class FilterAction extends PureComponent {
  render() {
    const { search, excel, reset, importData } = this.props.actions;
    return (
      <Fragment>
        {search &&
        <Button
          type='primary submit'
          onClick={search}
        >
          <div className='content-btn'>
            <span className='name'><Icon type="search" /> Tìm kiếm</span>
          </div>
        </Button>
        }
        {excel &&
        <Button onClick={excel} className='heading-button-export-excel'>
          <div>
            <span className='name'><Icon type="file-excel" /> Xuất excel</span>
          </div>
        </Button>
        }
        {reset &&
        <Button onClick={reset}>
          <div className='content-btn'>
            <span className='name'><Icon type="reload" /> Làm mới</span>
          </div>
        </Button>
        }
        {importData &&
        <Button onClick={importData}>
          <div className='content-btn'>
            <span className='name'><Icon type="import" /> Import dữ liệu</span>
          </div>
        </Button>
        }
      </Fragment>
    )
  }
}

FilterAction.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ])
}

export default FilterAction
